import { useContext, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { generalGet } from '../../../API/api';
import TableSkeleton from '../../../components/loaders/TableSkeleton';
import { useTranslation } from 'react-i18next';
import { authContext } from '../../../store/context/authContext';
import VehicleModelsEditLayout from '../../../modules/vehicleModels/components/VehicleModelsEditLayout';
import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useParams } from 'react-router-dom';

const VehicleModelEdit = () => {
  const { t, i18n } = useTranslation();
  const {id: makeId, modelId} = useParams()
  const { catchError } = useContext(authContext);
  const [modelData, setModelData] = useState<any>(null)

  const { data, isSuccess, isLoading, error } = useQuery({
    queryKey: ['models', modelId],
    queryFn: () => generalGet(`admin/makes/${makeId}/models/${modelId}`),
    refetchOnWindowFocus: false,
  });

  const dispatch = useDispatch();
  dispatch(
    setBreadCrumbsData({
      links: [{ label: t('links.vehicle_models') }],
      page_title: modelData?.name?.[i18n.language],
    })
  );

  useEffect(() => {
    const reqData = data?.data.data;
    if (isSuccess) {
      setModelData(reqData);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    error && catchError(error);
  }, [catchError, error]);

  if (isLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="vehicles-page-container">
      <VehicleModelsEditLayout data={modelData}/>
    </div>
  );
};

export default VehicleModelEdit;
